import { StrictMode, createRoot } from "@wordpress/element";
import TableComercios from "./TableComercios";

// Mount the component to the 'root' div
const root = document.getElementById('table-comercios');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <TableComercios />
    </StrictMode>
  );
}
